import { Reducer } from "redux";
import { ActionTypes } from "../Actions";

// for state its important to have initial default value
export const standalone: Reducer<boolean, ActionTypes> = (state = false /*, action*/) => {
    // return true;
    return state || (navigator as any).standalone || false;
};
